<!--食品安全 采购品资质下载-->
<template>
  <div>
    <el-row style="margin-top:24px">
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期"
              :clearable="false" :editable="false"></el-date-picker>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" filterable v-model="searchForm.supplier_name" placeholder="请选择" :clearable="true">
              <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select size="medium" v-model="searchForm.value" placeholder="请选择">
              <el-option v-for="item in PRODUCT_TYPE_LIST" :key="item.typeId" :label="item.name" :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="serch()" :loading="loadSearch">筛选</el-button>
            <el-button size="medium" @click="download('',2)">批量下载</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column prop="UPLOADED" label="状态">
            <template slot-scope="scope">
              {{ scope.row.UPLOADED === 0 ? '未上传' : (scope.row.UPLOADED === 1 ? '上传中' : '上传完成') }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-download" @click="download(scope.row,1)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { newSupplierName } from 'api/tcBanlance';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loadSearch: false,
      // 供应商数据
      supplier: [],
      // 列表数据
      tableData: [],
      // 状态
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '未上传' }, { typeId: 1, name: '上传中' }, { typeId: 2, name: '上传完成' }],
      // 筛选
      searchForm: {
        SEND_DAY: new Date().getTime() + 3600 * 1000 * 24,
        value: 0,
      },
      // 数据总条数
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      // 当前页
      currentPage: 1,
      // 多选
      multipleSelection: [],
    };
  },
  created() {
    // 页面筛选记忆
    if (this.PURCHASE_QUALIFICATION_DOWNLOAD_LIST) {
      this.searchForm = this.PURCHASE_QUALIFICATION_DOWNLOAD_LIST.CONDITION;
      this.currentPage = this.PURCHASE_QUALIFICATION_DOWNLOAD_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.querySupplier();
    this.queryData();
  },
  computed: {
    // 上一次的搜索结果和条件
    PURCHASE_QUALIFICATION_DOWNLOAD_LIST() {
      return this.$store.state.PURCHASE_QUALIFICATION_DOWNLOAD_LIST;
    },
  },
  methods: {
    // 获取供应商
    querySupplier() {
      const params = {};
      newSupplierName(params).then((res) => {
        if (res.length !== 0) {
          this.supplier = res[0].list;
        } else {
          this.supplier = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 搜索
    serch() {
      this.currentPage = 1;
      this.queryData();
    },
    // 翻页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 获取表格数据
    queryData() {
      if (!this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
      }
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 39,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        UPLOADED: this.searchForm.value,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.supplier_name) {
        params.SUPPLIER_ID = this.searchForm.supplier_name;
      }
      http.post(params).then((result) => {
        if (result[0].LIST.length !== 0) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 查看
    detail(row) {
      this.$router.push({ path: '/downloadQualificatDetail/detail' });
      sessionStorage.setItem('QUALIFICATION_SEND', date(this.searchForm.SEND_DAY, '%F'));
      sessionStorage.setItem('SUPPLIER_ID', row.SUPPLIER_ID);
    },
    // 下载/批量下载资质
    download(row, type) {
      let supplierIdList = [];
      if (type === 1) {
        // 下载
        supplierIdList.push(row.SUPPLIER_ID);
      } else if (type === 2) {
        // 批量下载
        if (this.multipleSelection.length == 0) {
          this.$message.show({ text: '请先勾选需要批量下载资质的供应商信息', type: 'warning' });
          return;
        }
        supplierIdList = this.multipleSelection;
      }
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 41,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: date(this.searchForm.SEND_DAY, '%F'),
        SUPPLIER_ID: supplierIdList,
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach((element) => {
        this.multipleSelection.push(element.SUPPLIER_ID);
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/foodSecurity/downloadQualificat.vue